import React, { PureComponent } from "react";
import "./DiamondInfoDetailPage.style.scss";
import DiamondcaratIcon from "Component/DiamondcaratIcon";
import DiamondcolorIcon from "Component/DiamondcolorIcon";
import DiamondclarityIcon from "Component/DiamondclarityIcon";
import DiamondcutIcon from "Component/DiamondcutIcon";
import DiamonddimensionsIcon from "Component/DiamonddimensionsIcon";
import DiamondcertificateIcon from "Component/DiamondcertificateIcon";
import DiamondClarityGradeImage from "Component/DiamondClarityGradeImage";
import DiamondColorGradeImage from "Component/DiamondColorGradeImage";
import Link from "@scandipwa/scandipwa/src/component/Link";
import { color_diamonds, colorless_diamonds } from "Src/Value/ColorDiamond_color";

class DiamondInfoDetailPageComponent extends PureComponent {
    static propTypes = {
        diamond: this.propTypes
    }

    state = {
        openCertificate: false,
    }

    renderDiamondCarat = (diamond_carat) => {
        return (
            diamond_carat &&
            <div className="DiamondInfo-Card">
                <div className="DiamondInfo-Card_Header">
                    <DiamondcaratIcon />
                    <span>Carat Weight</span>
                </div>

                <div className="DiamondInfo-Card_Info">
                    <span>{diamond_carat}</span>
                    <p>Universal measurement unit for diamonds</p>
                </div>
            </div>
        )
    }

    renderDiamondColor = (diamond_color, hasColor) => {
        if (hasColor && diamond_color) {
            const { diamond } = this.props;

            return (
                <div className="DiamondInfo-Card">
                    <div className="DiamondInfo-Card_Header">
                        <DiamondcolorIcon />
                        <span>Color</span>
                    </div>

                    <div className="DiamondInfo-Card_Info">
                        <span>{color_diamonds[diamond_color?.toLowerCase()]}</span>

                        <p>{diamond?.girdle_max}</p>
                    </div>
                </div>
            )
        }

        return (
            diamond_color &&
            <div className="DiamondInfo-Card">
                <div className="DiamondInfo-Card_Header">
                    <DiamondcolorIcon />
                    <span>Color</span>
                </div>

                <div className="DiamondInfo-Card_Info">
                    <span>{diamond_color}</span>
                    <div className={`DiamondGradeImage-Conatnet color-${diamond_color?.toLowerCase()}`}>
                        <DiamondColorGradeImage />
                    </div>
                    <p>{colorless_diamonds[diamond_color?.toLowerCase()]}</p>
                </div>
            </div>
        )
    }

    renderDiamondClarity = (diamond_clarity) => {
        return (
            diamond_clarity &&
            <div className="DiamondInfo-Card">
                <div className="DiamondInfo-Card_Header">
                    <DiamondclarityIcon />
                    <span>Clarity</span>
                </div>

                <div className="DiamondInfo-Card_Info">
                    <span>{diamond_clarity}</span>
                    <div className={`DiamondGradeImage-Conatnet clarity-${diamond_clarity?.toLowerCase()}`}>
                        <DiamondClarityGradeImage />
                    </div>
                    <p>Hard to see inclusions even under 10x magnification</p>
                </div>
            </div>
        )
    }

    renderDiamondCut = (diamond_cut) => {
        return (
            diamond_cut &&
            <div className="DiamondInfo-Card">
                <div className="DiamondInfo-Card_Header">
                    <DiamondcutIcon />
                    <span>Cut</span>
                </div>

                <div className="DiamondInfo-Card_Info">
                    <span>{diamond_cut}</span>
                    <p>Incredible fire and brilliance</p>
                </div>
            </div>
        )
    }

    renderDiamondDimenssions = (diamond_measurement, diamond_ratio) => {
        return (
            diamond_measurement &&
            <div className="DiamondInfo-Card">
                <div className="DiamondInfo-Card_Header">
                    <DiamonddimensionsIcon />
                    <span>Dimensions</span>
                </div>

                <div className="DiamondInfo-Card_Info">
                    <span>{diamond_measurement}</span>
                    {diamond_ratio && <p>Ratio: {diamond_ratio}</p>}
                </div>
            </div>
        )
    }

    renderDiamondCertificate = (diamond_certificate, diamond_created_from, cert_url) => {
        return (
            diamond_certificate &&
            <div className="DiamondInfo-Card">
                <div className="DiamondInfo-Card_Header">
                    <DiamondcertificateIcon />
                    <span>Certification</span>
                </div>

                <div className="DiamondInfo-Card_Info">
                    <span>{diamond_certificate}</span>
                    {diamond_created_from && <span className="Diamond_CreatedFrom">{diamond_created_from} Diamond</span>}
                    <Link isOpenInNewTab={true} to={cert_url}>
                        <p className="Diamond_CeritificateView">View Certificate</p>
                    </Link>
                </div>
            </div>
        )
    }

    render() {
        const { diamond } = this.props;

        return (
            <div className="DiamondInfoDetailSection">
                <h1 className="DiamondInfoDetailSection-Title">Diamond Info</h1>
                <div className="DiamondInfoDetailSection-Information">
                    {this.renderDiamondCarat(diamond?.diamond_carat)}
                    {this.renderDiamondColor(diamond?.diamond_color, diamond?.hasColor)}
                    {this.renderDiamondClarity(diamond?.diamond_clarity)}
                    {this.renderDiamondCut(diamond?.diamond_cut)}
                    {this.renderDiamondDimenssions(diamond?.diamond_measurement, diamond?.diamond_ratio)}
                    {this.renderDiamondCertificate(diamond?.diamond_certificate, diamond?.diamond_created_from, diamond?.cert_url)}
                </div>
            </div>
        );
    }
}

export default DiamondInfoDetailPageComponent;